import { MaterialIcons } from "@expo/vector-icons";
import { useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { Button, CollapsibleDrawer, StatusBanner, ThemedText, useCustomTheme, } from "@luna-restaurant/ui";
import { DrawerText } from "./DrawerText";
export const PreselectionContainer = ({ isEditingAllowed, hasBeenPublished, isNormalSchool, formattedMonthOnly, preselected, setPreselected, }) => {
    const { colors, fonts } = useCustomTheme();
    const [infoDrawerOpen, setInfoDrawerOpen] = useState(true);
    const [infoContainerIsHovered, setInfoContainerIsHovered] = useState(false);
    const [isApplySuggestionsHovered, setIsApplySuggestionsHovered] = useState(false);
    const { t } = useTranslation();
    const toggleInfoDrawer = () => {
        setInfoDrawerOpen((prev) => !prev);
    };
    const infoContainerStyle = infoContainerIsHovered || infoDrawerOpen
        ? { ...styles.infoContainer, ...styles.infoContainerHover }
        : styles.infoContainer;
    return (<View style={styles.container}>
      {hasBeenPublished ? (<StatusBanner type="success" message={t("mealPlan.monthSelectionCompleted", {
                month: formattedMonthOnly,
            })}/>) : (<>
          <View style={[
                styles.preselectionContainer,
                !preselected ? styles.preselectionButtonContainer : {},
                {
                    borderColor: preselected
                        ? colors.success
                        : colors.palette.lime50,
                    backgroundColor: preselected
                        ? colors.palette.spinach90
                        : colors.background,
                },
            ]}>
            {preselected ? (<>
                <MaterialIcons name="check-circle" size={24} color={colors.success}/>
                <ThemedText type="default" style={[styles.preselectionSubText, { ...fonts.bold }]}>
                  {t("mealPlan.preselected")}
                </ThemedText>
              </>) : (<>
                <Button buttonText={t("mealPlan.applySuggestions")} onPress={() => {
                    setPreselected(!preselected);
                }} onHoverIn={() => {
                    setIsApplySuggestionsHovered(true);
                }} onHoverOut={() => {
                    setIsApplySuggestionsHovered(false);
                }} iconName="star-circle" iconPosition="left" iconColor={colors.background} buttonStyle={[
                    styles.preselectionButton,
                    {
                        backgroundColor: isApplySuggestionsHovered
                            ? colors.palette.spinach20
                            : colors.palette.spinach30,
                    },
                ]} iconSize={24} buttonTextStyle={[
                    { color: colors.background, ...fonts.bold },
                    styles.preselectionButtonText,
                ]} disabled={!isEditingAllowed}/>
                <ThemedText type="default" style={[styles.preselectionSubText, { ...fonts.regular }]}>
                  {t("mealPlan.saveTime")}
                </ThemedText>
              </>)}
            {!isEditingAllowed && <View style={styles.disabledContainer}/>}
          </View>
          <Pressable style={[
                infoContainerStyle,
                {
                    backgroundColor: colors.warningLight,
                    outlineColor: colors.warning,
                },
            ]} onPress={toggleInfoDrawer} onHoverIn={() => setInfoContainerIsHovered(true)} onHoverOut={() => setInfoContainerIsHovered(false)}>
            <View style={styles.infoDrawerTitleContainer}>
              <View style={styles.infoDrawerTitleIconContainer}>
                <MaterialIcons name="notification-important" size={24} color="black"/>
                <ThemedText type="default" style={[styles.infoDrawerTitleText, { ...fonts.bold }]}>
                  {t("mealPlan.importantNoticeTitleText")}
                </ThemedText>
              </View>
              <Button buttonText={infoDrawerOpen ? t("common.close") : t("common.open")} onPress={toggleInfoDrawer} iconName={infoDrawerOpen ? "minus" : "plus"} iconPosition="right" iconColor={colors.text} iconSize={24} buttonTextStyle={[
                { ...fonts.bold },
                styles.infoDrawerTitleButtonText,
            ]} buttonStyle={[styles.infoDrawerToggleButton]}/>
            </View>
            <CollapsibleDrawer isOpen={infoDrawerOpen} hideScrollIndicators>
              <View style={styles.drawerContent}>
                <DrawerText title={t("mealPlan.importantNoticeTitle")} textContent={isNormalSchool
                ? t("mealPlan.importantNoticeNormalSchool")
                : t("mealPlan.importantNoticeSpecialSchool")} icon="warning"/>
                <DrawerText title="vegetarian" textContent={isNormalSchool
                ? t("mealPlan.importantNoticeNormalSchoolVegetarian")
                : t("mealPlan.importantNoticeSpecialSchoolVegetarian")} icon="warning"/>
                <DrawerText title="meat" textContent={t("mealPlan.meatNotice")}/>
                <DrawerText title="fish" textContent={t("mealPlan.fishNotice")}/>
              </View>
            </CollapsibleDrawer>
          </Pressable>
        </>)}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        gap: 24,
        width: "100%",
    },
    preselectionContainer: {
        display: "flex",
        flexDirection: "row",
        borderWidth: 1,
        borderRadius: 28,
        height: 58,
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 16,
        paddingVertical: 6,
        paddingHorizontal: 16,
        minWidth: 513,
    },
    preselectionButtonContainer: {
        paddingLeft: 6,
        paddingRight: 24,
    },
    preselectionButton: {
        height: 44,
        gap: 8,
        paddingHorizontal: 16,
    },
    preselectionButtonText: {
        fontSize: 16,
        lineHeight: 20.8,
    },
    preselectionSubText: {
        lineHeight: 20.8,
    },
    infoContainer: {
        flexDirection: "column",
        flex: 1,
        outlineStyle: "solid",
        outlineWidth: 1,
        borderRadius: 28,
        paddingHorizontal: 16,
    },
    infoContainerHover: {
        outlineWidth: 2,
        outlineOffset: -1,
    },
    infoDrawerTitleContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: 56,
    },
    infoDrawerTitleIconContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
    },
    infoDrawerTitleText: {
        lineHeight: 20.8,
    },
    infoDrawerTitleButtonText: {
        fontSize: 16,
        lineHeight: 20.8,
    },
    infoDrawerToggleButton: {
        paddingHorizontal: 0,
        height: 44,
        gap: 8,
    },
    drawerContent: {
        flexDirection: "row",
        gap: 16,
    },
    disabledContainer: {
        position: "absolute",
        borderRadius: 999,
        top: -4,
        left: -4,
        right: -4,
        bottom: -4,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        zIndex: 10,
        pointerEvents: "none",
    },
});
//# sourceMappingURL=PreselectionContainer.js.map